import { useRef } from "react";

/**
 * The latest value behind a stable ref, so a callback created once — a grid
 * option, a guard, a serial trigger — reads today's inputs when it runs
 * instead of the ones it closed over.
 */
export function useLatestRef<T>(value: T): { readonly current: T } {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
